import React from 'react';
import Popover from '@storeblocks/popover';
import Box from '@storeblocks/box';
import Hint from '@storeblocks/hint';
import { toInternalOptions } from './helpers';
import { AriaInfo, Label, LabelText, Options } from './styled';
export function RadioOptions({ id, name, direction, options, value, disabled, onChange, }) {
    const internalOptions = toInternalOptions(options);
    const handleChange = (event) => {
        var _a, _b;
        const internalDisabled = disabled || ((_b = (_a = event.target.attributes) === null || _a === void 0 ? void 0 : _a['aria-disabled']) === null || _b === void 0 ? void 0 : _b.value) === 'true';
        if (!internalDisabled) {
            const { value: internalValue } = event.target;
            const selected = options.find((option) => option.value === internalValue);
            onChange(event, selected);
        }
    };
    return (React.createElement(Options, { direction: direction }, internalOptions.map((option) => {
        const labelId = `label-${id}-${option.id}`;
        const optionId = `${id}-${option.id}`;
        const hintId = `option-hint-${optionId}`;
        const infoId = `option-info-${optionId}`;
        const infoTabIndex = !value || option.value === value ? 0 : -1;
        return (React.createElement(React.Fragment, { key: optionId },
            React.createElement(Box, { background: "inherit" },
                React.createElement("input", Object.assign({ type: "radio", name: name, id: optionId, key: optionId, value: option.value, checked: value === option.value, onChange: handleChange, "aria-disabled": disabled || option.disabled, "aria-labelledby": labelId, "data-trackid": option.trackid }, option.inputProps)),
                React.createElement(Label, Object.assign({ id: labelId, htmlFor: optionId, checked: value === option.value, "aria-disabled": disabled || option.disabled }, option.labelProps),
                    React.createElement(LabelText, null, option.label)),
                option.info && (React.createElement(Popover, Object.assign({ buttonProps: { tabIndex: infoTabIndex } }, option.popoverProps), option.info))),
            option.hint && (React.createElement(Hint, Object.assign({ id: hintId }, option.hintProps), option.hint)),
            option.info && React.createElement(AriaInfo, { id: infoId }, option.info)));
    })));
}
